import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import Card from "../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../Base/Services/ToastService";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";

import { chageEstadoExtensiones, getExtensiones, getRedes, getRedTelefonia, getRedVideo, getRouters } from "../../../../../API/IT/Dispositivos/DispositivosRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";

import RoutersScreen from "./Routers/RoutersScreen";
import RouterCRUD from "./Routers/RouterCRUD";
import RedesScreen from "./Redes/RedesScreen";
import RedCRUD from "./Redes/RedCRUD";
import RedVideoScreen from "./RedVideo/RedVideoScreen";
import RedVideoCRUD from "./RedVideo/RedVideoCRUD";
import RedTelefoniaScreen from "./RedTelefonia/RedTelefoniaScreen";
import RedTelefoniaCRUD from "./RedTelefonia/RedTelefoniaCRUD";
import ExtensionesCRUD from "./ExtensionesCRUD";

const TabDispositivosScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [activeIndex, setActiveIndex] = useState(0);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [routers, setRouters] = useState([]);
  const [redes, setRedes] = useState([]);
  const [redVideos, setRedVideos] = useState([]);
  const [redTelefonia, setRedTelefonia] = useState([]);
  const [extensiones, setExtensiones] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogRed, setShowDialogRed] = useState(false);
  const [showDialogRedVideo, setShowDialogRedVideo] = useState(false);
  const [showDialogRedTelefonia, setShowDialogRedTelefonia] = useState(false);
  const [showDialogExt, setShowDialogExt] = useState(false);
  const [estados, setEstados] = useState([]);
  const { userAuth } = useContext(AuthContext);
  

  const getInfo = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);
    if (activeIndex === 0) {
      const a = await getRouters();
      setRouters(a);
    } else if (activeIndex === 1) {
      const redTempo = await getRedes();
      setRedes(redTempo);
    } else if (activeIndex === 2) {
      const tempo = await getRedVideo();
      setRedVideos(tempo);
    } else if (activeIndex === 3) {
      const telTempo = await getRedTelefonia();
      setRedTelefonia(telTempo);
    } else if(activeIndex === 4) {
      const extensionesTempo = await getExtensiones();
      setExtensiones(extensionesTempo);
    }
    setLoading(false);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          placeholder="Estados"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdExtension: item.IdExtension,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdExtension: data.IdExtension,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} ${changes.length} Extensiones?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdExtensiones = changes.map((item) => item.IdExtension);
                cambiarEstado(e.value.IdStatus, IdExtensiones.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdExtensiones) => {
    const result = await chageEstadoExtensiones({ IdStatus, IdExtensiones });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const colums = [
    {
      field: "IdExtension",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth?.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogExt(true);
        setSelected([data]);
      },
    },
    {
      field: "Extension",
      header: "Extension",
      headerEn: "Extension",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialogExt(true);
        setSelected([data]);
      },
    },
    {
      field: "CodigoPersonal",
      header: "Código Personal",
      headerEn: "Personal Code",
      className: "Xsmall",
      Format: 'Modal',
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        setShowDialogExt(true);
        setSelected([data]);
      },
    },
    {
      field: "NombreLargo",
      header: "Nombre Personal",
      headerEn: "Personal Name",
      className: "XXlarge",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "small",
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      flex: 1,
      minWidth: 200,
    },
    {
      header: "Estado",
      headerEn: "Status",
      frozen: true,
      alignFrozen: "right",
      field: "IdEstado",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: true,
    },
    {
      field: "IdExtension",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialogExt(true);
            setSelected([rowData]);
          },
        },
      ],
    },
  ];
  
  const table = {
    Columns: colums,
    Data: extensiones,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
  };
  

  const openCrud = async () => {
    setLoading(true);
    if (activeIndex === 0) {
      setShowDialog(true);
      setSelected([]);
    } else if (activeIndex === 1) {
      setShowDialogRed(true);
      setSelected([]);
    } else if (activeIndex === 2) {
      setShowDialogRedVideo(true);
      setSelected([]);
    } else if (activeIndex === 3) {
      setShowDialogRedTelefonia(true);
      setSelected([]);
    } else if (activeIndex === 4) {
      setShowDialogExt(true)
      setSelected([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Dispositivos", config.language));
  }, []);

  useEffect(() => {
    getInfo();
  }, [activeIndex]);

  return (
    <div
      className="p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />

      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Dispositivos", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon="pi pi-plus" severity="success" onClick={openCrud} />
          </div>
        }
        contenido={
          <TabView
            style={{ marginTop: "30px" }}
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <TabPanel header={"Routers"}>
              <div style={{ height: "82vh" }}>
                <RoutersScreen
                  routers={routers}
                  selected={selected}
                  setSelected={setSelected}
                  loading={loading}
                  setShowDialog={setShowDialog}
                  toast={toast}
                  estados={estados}
                  getInfo={getInfo}
                />
              </div>
            </TabPanel>

            <TabPanel header={"Red"}>
              <div style={{ height: "82vh" }}>
                <RedesScreen
                  redes={redes}
                  selected={selected}
                  setSelected={setSelected}
                  loading={loading}
                  setShowDialog={setShowDialogRed}
                  toast={toast}
                  estados={estados}
                  getInfo={getInfo}
                />
              </div>
            </TabPanel>

            <TabPanel header={"Video"}>
              <div style={{ height: "82vh" }}>
                <RedVideoScreen
                  redVideos={redVideos}
                  selected={selected}
                  setSelected={setSelected}
                  loading={loading}
                  setShowDialog={setShowDialogRedVideo}
                  toast={toast}
                  estados={estados}
                  getInfo={getInfo}
                />
              </div>
            </TabPanel>

            <TabPanel header={"Telefonía"}>
              <div style={{ height: "82vh" }}>
                <RedTelefoniaScreen
                  redTelefonias={redTelefonia}
                  selected={selected}
                  setSelected={setSelected}
                  loading={loading}
                  setShowDialog={setShowDialogRedTelefonia}
                  toast={toast}
                  estados={estados}
                  getInfo={getInfo}
                />
              </div>
            </TabPanel>

            <TabPanel header={"Extensiones"}>
              <div style={{ height: "82vh" }}>
                <AgGrid table={table} />
              </div>
            </TabPanel>
          </TabView>
        }
      />

      <RouterCRUD
        listRouters={routers}
        showDialog={showDialog}
        router={selected}
        setShowDialog={setShowDialog}
        getInfo={getInfo}
      />

      <RedCRUD
        listRedes={redes}
        showDialog={showDialogRed}
        red={selected}
        setShowDialog={setShowDialogRed}
        getInfo={getInfo}
      />

      <RedVideoCRUD
        listRedVideo={redVideos}
        showDialog={showDialogRedVideo}
        redVideo={selected}
        setShowDialog={setShowDialogRedVideo}
        getInfo={getInfo}
      />

      <RedTelefoniaCRUD
        listRedTelefonia={redTelefonia}
        showDialog={showDialogRedTelefonia}
        redTelefonia={selected}
        setShowDialog={setShowDialogRedTelefonia}
        getInfo={getInfo}
      />

      {showDialogExt && (
        <ExtensionesCRUD
          showDialog={showDialogExt}
          setShowDialog={setShowDialogExt}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
        />      
      )}
    </div>
  );
};

export default TabDispositivosScreen;
